<template>
  <!-- prettier-ignore -->
  <div
    class="ovp-basket-widget ovp-a11y-container"
    :app-version="version$"
    :app-name="appName$"
    :app-language="locale"
  >
    <basket-container
      :options="{ configuratorUrl, source: $props.source }"
    />

    <screen-auth />
    <ovp-confirmation />
    <ovp-loading />
    <div id="modals"></div>
    <notifications />
    <ovp-medical-office-search />
  </div>
</template>

<script setup>
import { computed, inject, onBeforeMount } from 'vue'

import ScreenAuth from '@/components/Screen/OvpScreenAuth'
import BasketContainer from '@/components/BasketWidget/BasketContainer'
import OvpConfirmation from '@/components/Modal/Confirmation'
import Notifications from '@/components/Container/Notifications'
import OvpLoading from '@/components/Container/Loading'
import OvpMedicalOfficeSearch from '@/components/MedicalSearch/MedicalOfficeSearch'

import { useApplication, useBasket, useSession, useSurvey, useTranslation } from '@/hooks'
import { events$ } from '@/services'

import { EVENT_DOTCOM_SURVEY_WEBSITE, SOURCE } from '@/config/events'
import { SURVEY_TOUCHPOINT_WEBSITE } from '@/config/constants'
import { useI18n } from 'vue-i18n'

// Hooks
const version$ = inject('version$')
const appName$ = inject('appName$')
const { getDvpUrl, initializeClearSequence } = useApplication()
const { basket } = useBasket()
const { autostart } = useSession()
const { triggerSurvey } = useSurvey()
const { locale } = useI18n()
const { browserLanguage, updateTranslations } = useTranslation()

// Props
defineProps({
  source: {
    type: String,
    default: SOURCE.BASKET_WIDGET,
  },
})

// Computed
const configuratorUrl = computed(() => {
  return getDvpUrl(locale.value)
})

// Lifecycle hooks
initializeClearSequence()
onBeforeMount(async () => {
  await autostart()

  if (basket.language.toLowerCase() !== browserLanguage) {
    await updateTranslations(browserLanguage)
  }

  events$.once(EVENT_DOTCOM_SURVEY_WEBSITE, () => {
    triggerSurvey({
      touchPoint: SURVEY_TOUCHPOINT_WEBSITE,
      language: locale.value,
    })
  })
})
</script>

<style name="global" scoped>
* {
  & :deep(button) {
    font-weight: bold;
  }

  & :deep(button),
  input,
  select {
    font-family: Open Sans, sans-serif !important;
  }
}
</style>
